module.exports = __webpack_public_path__ + "media/images/bg-bonds-df95b178d8f3a757d561a1a9aae8e3b9.jpg";